import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Pages
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Play from './pages/Play';
import SmartPractice from './pages/SmartPractice';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import WordDetail from './pages/WordDetail';
import Words from './pages/Words';
import { SmartRead } from './pages/SmartRead';
import { SmartReadArticle } from './pages/SmartReadArticle';

// Components
import Layout from './components/Layout';
import Meta from './components/Meta';

const App = () => {
  return (
    <HelmetProvider>
      <Meta />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="play" element={<Play />} />
          <Route path="smart-practice" element={<SmartPractice />} />
          <Route path="smart-read" element={<SmartRead />} />
          <Route path="smart-read/:id" element={<SmartReadArticle />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/:username" element={<Profile />} />
          <Route path="user/:username" element={<Profile />} />
          <Route path="words" element={<Words />} />
          <Route path="words/:wordId" element={<WordDetail />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
};

export default App;
